<template>
  <div>
    <h2>
      Constraints and Defaults
    </h2>
    <el-form
      ref="form"
      :rules="rules"
      :model="item"
    >
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            label="Default cubic"
            prop="default_cubic"
          >
            <el-input
              v-model="item.default_cubic"
              type="number"
              placeholder="Default cubic"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            label="Allow DG"
            label-position="right"
            prop="allow_dg"
          >
            <el-switch
              v-model="item.allow_dg"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            label="Tailgate"
            label-position="right"
            prop="service_supports_tailgate"
          >
            <el-switch
              v-model="item.service_supports_tailgate"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            label="Timeslot Deliveries"
            label-position="right"
            prop="service_supports_timeslot"
          >
            <el-switch
              v-model="item.service_supports_timeslot"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            label="Moffett"
            label-position="right"
            prop="service_supports_moffett"
          >
            <el-switch
              v-model="item.service_supports_moffett"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            label="Hand Unload"
            label-position="right"
            prop="service_supports_handunload"
          >
            <el-switch
              v-model="item.service_supports_handunload"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            label="Two Man Lift"
            label-position="right"
            prop="service_supports_twomanlift"
          >
            <el-switch
              v-model="item.service_supports_twomanlift"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            label="Saturday Delivery"
            label-position="right"
            prop="service_supports_saturdaydelivery"
          >
            <el-switch
              v-model="item.service_supports_saturdaydelivery"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            label="PO Box"
            label-position="right"
            prop="service_supports_pobox"
          >
            <el-switch
              v-model="item.service_supports_pobox"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default: null,
      required: true
    }

  },
  data () {
    return {
      itemModel: null,
      rules: {
        allow_dg: [
          { required: true, message: 'Allow DG is required.', trigger: ['blur'] }
        ],
        default_cubic: [
          { required: true, message: 'Default cubic is required.', trigger: ['blur'] }
        ]
      }
    }
  },
  methods: {
  }
}
</script>
